/**
 * Fixes a bug in the theme's <quantity-selector> component (assets/theme.js):
 * its button click handler does `this.input.quantity = this.input.quantity + 1`,
 * but the plain <input> it wraps has no `quantity` property, so clicking the
 * +/- buttons silently does nothing. Kept as a separate file instead of editing
 * theme.js directly so theme updates stay easy to apply.
 *
 * Runs in the capture phase so it updates the input before the original
 * (broken) per-button listener runs; that listener then sees the value already
 * changed and no-ops harmlessly, so no duplicate "change" event is dispatched.
 */
document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest('quantity-selector .quantity__button');
    if (!button) return;

    const wrapper = button.closest('quantity-selector');
    const input = wrapper && wrapper.querySelector('input');
    if (!input) return;

    const previousValue = input.value;

    if (button.name === 'plus') {
      input.stepUp();
    } else {
      input.stepDown();
    }

    if (previousValue !== input.value) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  },
  true
);
